export const isInt = (n: number): boolean => Number(n) === n && n % 1 === 0;
export const isFloat = (n: number): boolean => Number(n) === n && n % 1 !== 0;
export const isNumber = (value: any): boolean => typeof value === 'number';
